export default "__VITE_ASSET__x4quVR4I__"